module.exports = __webpack_public_path__ + "static/media/unlock-2x.e148841a.png";